class GiftWrapping extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkbox = this.querySelector("#gift-wrapping");
    this.settings = JSON.parse(this.querySelector("[data-gift-wrap-settings]").textContent);
    this.christmasInput = this.querySelector("#gift-wrapping-christmas");
    this.christmasLabel = this.querySelector('label[for="gift-wrapping-christmas"]');

    // Initial visibility of Christmas option
    if (this.christmasLabel) {
      this.christmasLabel.hidden = !this.checkbox.checked;
    }

    // If gift wrap is already selected on load, sync Christmas checkbox from cart
    if (this.checkbox.checked && this.christmasInput) {
      this.syncChristmasFromCart();
    }

    this.checkbox.addEventListener("change", async (event) => {
      if (event.target.checked) {
        if (this.christmasLabel) this.christmasLabel.hidden = false;
        const christmasSelected = this.christmasInput ? !!this.christmasInput.checked : null;
        await this.addGiftWrappingProduct(christmasSelected);
      } else {
        await this.removeGiftWrappingProduct();
        if (this.christmasLabel) this.christmasLabel.hidden = true;
        if (this.christmasInput) this.christmasInput.checked = false;
      }
    });

    if (this.christmasInput) {
      this.christmasInput.addEventListener("change", async (event) => {
        await this.setChristmasWrapping(!!event.target.checked);
      });
    }
    
    document.addEventListener('cart:change', (event) => {
      if (event.detail.cart.items.length === 1 && event.detail.cart.items[0].id === this.settings.variantId) {
        this.removeGiftWrappingProduct();
      }
    });
  }

  cartRefresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }

  async addGiftWrappingProduct(withChristmas = null) {
    try {
      const payload = {
        id: this.settings.variantId,
        quantity: 1
      };
      if (withChristmas !== null) {
        payload.properties = {
          "_Christmas-Wrapping": withChristmas
        };
      }
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload),
      });
      await response.json();
      this.cartRefresh();
    } catch (error) {
      console.error("Error adding gift wrapping product:", error);
    }
  }

  async removeGiftWrappingProduct() {
    try {
      const cart = await (await fetch("/cart.js")).json();
      const item = cart.items.find(
        (cartItem) => cartItem.variant_id === this.settings.variantId
      );
      if (item) {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
          }),
        });
        await response.json();
        this.cartRefresh();
      }
    } catch (error) {
      console.error("Error removing gift wrapping product:", error);
    }
  }

  async getGiftWrapItem() {
    try {
      const cart = await (await fetch("/cart.js")).json();
      return cart.items.find(
        (cartItem) => cartItem.variant_id === this.settings.variantId
      ) || null;
    } catch (error) {
      console.error("Error retrieving cart:", error);
      return null;
    }
  }

  async updateGiftWrapProperties(properties) {
    try {
      const item = await this.getGiftWrapItem();
      if (!item) return;
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: item.key,
          properties
        }),
      });
      await response.json();
      this.cartRefresh();
    } catch (error) {
      console.error("Error updating gift wrapping properties:", error);
    }
  }

  async setChristmasWrapping(isChristmas) {
    // Ensure the base gift wrapping is selected before setting property
    if (!this.checkbox.checked) return;
    const item = await this.getGiftWrapItem();
    if (item) {
      await this.updateGiftWrapProperties({ "_Christmas-Wrapping": isChristmas });
    } else {
      await this.addGiftWrappingProduct(isChristmas);
    }
  }

  async syncChristmasFromCart() {
    if (!this.christmasInput) return;
    const item = await this.getGiftWrapItem();
    if (item && item.properties) {
      const value = item.properties["_Christmas-Wrapping"];
      // Coerce to boolean
      const boolValue = typeof value === "boolean" ? value : String(value).toLowerCase() === "true";
      this.christmasInput.checked = !!boolValue;
    }
  }
}

customElements.define("gift-wrapping", GiftWrapping);
